import { OrderRoutingService } from '../routing'
import { OrderService } from '../services/OrderService'
import { useOrderStore } from '../store'

import { OrderSupport } from '#Order/support/OrderSupport'

export const useOrder = () => {
  const alt = useAlt()

  return {
    get service() { return alt.get(OrderService) },
    get store() { return useOrderStore() },
    get routing() { return alt.get(OrderRoutingService) },
    get support() { return alt.get(OrderSupport) },
  }
}
